import { render } from "./ViewTemplate.vue?vue&type=template&id=300fb392&scoped=true"
import script from "./ViewTemplate.vue?vue&type=script&lang=ts"
export * from "./ViewTemplate.vue?vue&type=script&lang=ts"

import "./ViewTemplate.vue?vue&type=style&index=0&id=300fb392&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-300fb392"

export default script